<template>
  <div class="home">
    <v-container grid-list-md>
      <v-layout row justify-center>
        <v-flex xs12 md9>
          <v-layout column align-center justify-space-between>
            <v-flex mb-5 mt-5>
              <img
                :src="require('@/assets/hil-logo-text-white.png')"
                width="200px"
              />
            </v-flex>
            <v-flex>
              <SignupForm v-if="isLogged === false" />
              <div v-else>
                Connecté
              </div>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
    <div class="motto">Ne cherchez plus, Home In Love trouve pour vous !</div>
  </div>
</template>

<script>
import SignupForm from "../components/SignupForm";

export default {
  name: "home",
  components: {
    SignupForm
  },
  data() {
    return {
      loading: false
    };
  },
  computed: {
    isLogged() {
      return this.$store.state.user.isLogged;
    }
  }
};
</script>

<style>
.motto {
  position: absolute;
  bottom: 20px;
  left: 0;
  right: 0;
  text-align: center;
  color: white;
  font-size: 18pt;
}
</style>
